/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Subtitle_Exported_MessageInputs */

const en_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle exported successfully`)
};

const fr_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sous-titres exportes avec succes`)
};

const de_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel erfolgreich exportiert`)
};

const it_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitolo esportato correttamente`)
};

const ru_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры успешно экспортированы.`)
};

const es_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtítulo exportado exitosamente`)
};

const zh_cn2_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕导出成功`)
};

const ja_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕のエクスポートに成功しました`)
};

const hi_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक सफलतापूर्वक निर्यात हो गया`)
};

const pt_pt2_iframe_remote_subtitle_exported_message = /** @type {(inputs: Iframe_Remote_Subtitle_Exported_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda exportada com sucesso`)
};

/**
* | output |
* | --- |
* | "Subtitle exported successfully" |
*
* @param {Iframe_Remote_Subtitle_Exported_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_subtitle_exported_message = /** @type {((inputs?: Iframe_Remote_Subtitle_Exported_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Subtitle_Exported_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_subtitle_exported_message(inputs)
	if (locale === "de") return de_iframe_remote_subtitle_exported_message(inputs)
	if (locale === "it") return it_iframe_remote_subtitle_exported_message(inputs)
	if (locale === "ru") return ru_iframe_remote_subtitle_exported_message(inputs)
	if (locale === "es") return es_iframe_remote_subtitle_exported_message(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_subtitle_exported_message(inputs)
	if (locale === "ja") return ja_iframe_remote_subtitle_exported_message(inputs)
	if (locale === "hi") return hi_iframe_remote_subtitle_exported_message(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_subtitle_exported_message(inputs)
	return en_iframe_remote_subtitle_exported_message(inputs)
});